import { render, staticRenderFns } from "./CardPointsList.vue?vue&type=template&id=3f3f9398"
import script from "./CardPointsList.vue?vue&type=script&lang=js"
export * from "./CardPointsList.vue?vue&type=script&lang=js"
import style0 from "./CardPointsList.vue?vue&type=style&index=0&id=3f3f9398&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports